<template>
    <div id="dispatchReady">
        <el-col class="searthPart" style="width: 100%;">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input style="width: 150px" v-model.trim="searchForm.address" clearable placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 150px" v-model.trim="searchForm.label" clearable placeholder="请输入编组名称"></el-input>
                </el-form-item>
                <el-select multiple filterable clearable v-model="searchForm.orderIdentifierList" placeholder="渠道" style="width:300px">
                    <el-option v-for="item,index in OrderNolList"
                        :key="index"
                        :label="item.paraName"
                        :value="item.paraValue">
                    </el-option>
                </el-select>
                <el-form-item  style="width: 100px;">
                    <el-select
                        filterable
                        clearable
                        v-model="searchForm.province"
                        @change="choseProvince"
                        placeholder="省" >
                        <el-option
                            v-for="item,index in provinceList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="width:100px" v-if="searchForm.province">
                    <el-select
                        filterable
                        clearable
                        v-model="searchForm.city"
                        @change="choseCity"
                        placeholder="市">
                        <el-option
                            v-for="item,index in cityList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="width:100px;" v-if="searchForm.city">
                    <el-select
                        filterable
                        clearable
                        v-model="searchForm.county"
                        placeholder="区">
                        <el-option
                            v-for="item,index in areaList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-right:20px">
                    <el-select filterable style="width: 80px" v-model="periodType" placeholder="请选择预派时间">
                        <el-option v-for="(item,index) in pickingTimeList"
                            :label="item.paraName"
                            :value="item.paraValue"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="getSendOrderList" size="small">查询</el-button>
                </el-form-item>
                <el-form-item class="fr">
                    <el-col class="fr" style="width:600px;text-align:right">
                        <el-button type="success" size="small" v-if="basicsAuth.newLable" @click="newGroup">新建编组</el-button>
                        <!-- <el-button type="success" size="small" v-if="basicsAuth.editLabel" @click="eidtGroup">修改编组</el-button> -->
                        <el-button type="success" size="small" v-if="basicsAuth.sendGroupOrders" @click="newDispatchDialog(0)">批量派单</el-button>
                        <el-button type="success" size="small"  @click="newDispatchDialog(1)">批量改派</el-button>
                        <el-button type="success" size="small" v-if="basicsAuth.newLable" @click="cancelDispatchGroup">批量解散</el-button>
                        <el-button type="success" size="small" @click="downLoad.exportExcel('tableId')">导出</el-button>
                        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                    </el-col>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col style="width: 100%;">
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    id="tableId"
                    :data="returnData"
                    :span-method="objectSpanMethod"
                    :row-class-name="tableRowClassName"
                    @cell-mouse-leave="cellMouseLeave"
                    @cell-mouse-enter="cellMouseEnter"
                    border
                    :height="tableHeight"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                 <!--    <el-table-column
                        align="center"
                        width="80"
                        label="">
                        <template slot-scope="scope">
                            <el-checkbox @change="checkFuc(scope.row)" v-model="scope.row.selected" :checked="scope.row.selected"></el-checkbox>
                        </template>
                    </el-table-column> -->
                    <el-table-column
                        align="center"
                        prop="label"
                        width="100"
                        label="编组名称">
                        <template slot-scope="scope">
                            <el-checkbox @change="checkFuc(scope.row)" v-model="scope.row.selected" :checked="scope.row.selected"></el-checkbox>&nbsp;&nbsp;{{scope.row.label}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="left"
                        width="150"
                        label="机型">
                        <template slot-scope="scope" >
                            <el-checkbox v-if="scope.row.label" v-model="scope.row.selected" :checked="scope.row.selected"></el-checkbox>&nbsp;&nbsp;{{scope.row.modelName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="80"
                        align="center"
                        prop="colorName"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        width="150"
                        align="center"
                        label="故障">
                        <template slot-scope="scope">
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassShortName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        prop="onsiteDate"
                        label="预约日期">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="120"
                        label="预约时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.onsiteTimeStart}}~{{scope.row.onsiteTimeEnd}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="80"
                        align="center"
                        label="区域">
                        <template slot-scope="scope">
                            {{scope.row.countyName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="330"
                        align="left"
                        label="地址">
                        <template slot-scope="scope">
                            {{scope.row.address}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="110"
                        align="center"
                        label="工程师">
                        <template slot-scope="scope">
                            <span v-if="(scope.row.serviceType == 'QS' || scope.row.serviceType == 'QD') && scope.row.isFetch != 2 ">{{scope.row.fetchName}}</span>
                            <span v-else-if="scope.row.sendMachineWay == 3">{{scope.row.sendName}}</span>
                            <span v-else>{{scope.row.engineerName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="left"
                        prop="handleRemark"
                        width="800"
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        width="120"
                        align="center"
                        label="订单渠道">
                        <template slot-scope="scope">
                            {{ scope.row.orderIdentifier | sysCodeFileter('order_identifier') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="100"
                        align="center"
                        fixed="right"
                        label="完成度">
                        <template slot-scope="scope">
                            {{scope.row.adminStatus | sysCodeFileter('admin_status')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="220"
                        prop="orderNo"
                        label="订单号">
                        <template slot-scope="scope">
                            {{scope.row.orderNo}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="80"
                        align="center"
                        fixed="right"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="newModel(scope.row,0)" style="padding:7px" v-if="(scope.row.adminStatus == '38' || scope.row.adminStatus == '03') && basicsAuth.sendOrders" size="mini">派单</el-button>
                            <el-button type="primary" @click="newModel(scope.row,1)" style="padding:7px" v-if="(scope.row.adminStatus != '38' && scope.row.adminStatus != '03' && basicsAuth.revertOrders)" size="mini">改派</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <p style="text-align:left;line-height:80px;font-size:20px;color:#000">总条数：{{returnData.length}}/条</p>
            </el-card>
            <!-- 派单&改派编组弹出框 Start -->
                <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dislogModel" :close-on-click-modal="false" width="700px" :modal-append-to-body="false"  @close="emptyModelDialog('modelForm')">
                    <el-form ref="modelForm" :model="modelForm" label-width="95px" :label-position="labelPosition" :rules="modelFormRules" >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="订单号">
                                    <el-input clearable disabled v-model.trim="modelForm.orderNo" placeholder="请输入关联工单"></el-input>
                                </el-form-item>
                                <el-form-item label="所在区域">
                                    <el-input clearable disabled v-model.trim="modelForm.countyName"></el-input>
                                </el-form-item>
                                <el-form-item label="预约时间">
                                    <el-input clearable disabled v-model.trim="modelForm.time"></el-input>
                                </el-form-item>
                                <el-form-item label="颜色">
                                    <el-input clearable disabled v-model.trim="modelForm.colorName"></el-input>
                                </el-form-item>
                                <el-form-item label="已派工程师">
                                    <el-input clearable disabled v-model.trim="modelForm.engineerName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所在城市">
                                    <el-input clearable disabled v-model.trim="modelForm.cityName"></el-input>
                                </el-form-item>
                                <el-form-item label="地址详情">
                                    <el-input clearable disabled v-model.trim="modelForm.address"></el-input>
                                </el-form-item>
                                <el-form-item label="设备详情">
                                    <el-input clearable disabled v-model.trim="modelForm.modelDetail"></el-input>
                                </el-form-item>
                                <el-form-item label="故障详情" prop="faultSubclassStr">
                                    <el-input clearable disabled type="textarea" v-model.trim="modelForm.faultSubclassStr"></el-input>
                                </el-form-item>
                                <el-form-item label="工程师" prop="engineerId">
                                    <el-select v-model="modelForm.engineerId" @change="changeEnginner" :filter-method="PinyinMatch" filterable placeholder="请选择改派工程师" style="width: 100%;" clearable>
                                        <el-option v-for="(item,index) in pickingPointEngineerList"
                                            :label="item.name"
                                            :value="item.id"
                                            :key="index">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <span slot="footer"  class="dialog-footer" style="text-align: center">
                        <el-button type="success" v-if="dialogModelStatus == 'create'" @click="addModelFormSubmitBtn('modelForm',0)">确认</el-button>
                        <el-button type="success" v-if="dialogModelStatus == 'update'" @click="addModelFormSubmitBtn('modelForm',1)">确认</el-button>
                    </span>
                </el-dialog>
            <!-- 派单&改派编组弹出框 End -->

            <!-- 新建&修改编组弹出框 Start-->
                <el-dialog :title="textGroupMenu[dialogGroupStatus]" @click="emptyGroupDialog" :visible.sync="dialogGropFormVisible" width="400px">
                    <el-form :model="groupForm" ref="groupForm" :label-position="labelPosition">
                        <el-form-item label="编组名称：" >
                            <el-autocomplete
                                v-model="groupForm.label"
                                :fetch-suggestions="querySearchAsync"
                                placeholder="请输入编组名称">
                            </el-autocomplete>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button size="small" @click="emptyGroupDialog">取 消</el-button>
                        <el-button v-if="dialogGroupStatus == 'update'" size="small" type="primary" @click="setOrderLabelFuc">保 存</el-button>
                        <el-button v-if="dialogGroupStatus == 'create'" size="small" type="primary" @click="setOrderLabelFuc">新 建</el-button>
                    </div>
                </el-dialog>
            <!-- 新建&修改编组弹出框 End-->

            <!-- 批量派单弹出框 Start-->
                <el-dialog :title="textBatchMenu[dialogBatchStatus]" title="批量派单" @click="emptyDispatchDialog" :visible.sync="dialogDispatchForm" width="400px">
                    <el-form :model="dispatchForm" ref="dispatchForm" :label-position="labelPosition" :rules="dispatchFormRules" label-width="85px">
                        <el-form-item label="编组名称：" >
                            <el-input style="width:212px;" disabled v-model.trim="dispatchForm.label"></el-input>
                        </el-form-item>
                        <el-form-item label="订单数量：">
                            <el-input style="width:212px;" disabled v-model.trim="dispatchForm.nums"></el-input>
                        </el-form-item>
                        <el-form-item label="工程师：" prop="engineerId">
                            <el-select v-model="dispatchForm.engineerId" filterable placeholder="请选择改派工程师" clearable>
                                <el-option v-for="(item,index) in pickingPointEngineerList"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="index">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button size="small" @click="emptyDispatchDialog">取 消</el-button>
                        <el-button size="small" type="primary" v-if="dialogBatchStatus == 'create'" @click="dispatchFormSubmitBtn('dispatchForm')">确 认</el-button>
                        <el-button size="small" type="primary" v-if="dialogBatchStatus == 'update'" @click="dispatchRevertFormSubmitBtn('dispatchForm')">确 认</el-button>
                    </div>
                </el-dialog>
            <!-- 批量派单弹出框 End-->

        </el-col>
    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match';
    import {querySysRegion} from '@/api/system'
    import {selectWorkOrder, getLabelList,querySendOrderList,queryRegion,revertSendOrders,engineerListArea,sendOrdersBatch,setOrderLabel,sendOrders,revertOrdersBatch} from "../../api/order";
    import { selectParameterInfoBusiness,zhselectParameterInfoBusiness } from '@/api/api'
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'dispatchReady',
        data () {
            return {
                labelPosition:'left',
                copy:[],
                pickingPointEngineerList:[],   //指定工程师数组
                OrderNolList:[],
                provinceList:[],
                cityList:[],
                areaList:[],
                pickingTimeList:[
                    {
                        paraName:'今天',
                        paraValue:0
                    },
                    {
                        paraName:'明天',
                        paraValue:1
                    },
                    {
                        paraName:'后天',
                        paraValue:2
                    },
                    {
                        paraName:'大后天',
                        paraValue:3
                    },
                    {
                        paraName:'大大后天',
                        paraValue:4
                    },
                    {
                        paraName:'外后天',
                        paraValue:5
                    }
                ],
                searchForm:{
                    province:'',
                    city:'',
                    county:'',
                    orderIdentifierList:[],
                    address:'',                //详细地址
                    label:'',                  //编组名称
                    onsiteTimeStarts:'',       //派单开始时间
                    onsiteTimeEnds:'',         //派单结束时间
                    isNeedLabelSort:1,         //编组排序
                    startRow:1,
                    pageSize:10000,
                    adminStatusList:["03", "05", "06", "07", "38", "39","40"] //派单状态

                },
                periodType:0,    //预派时间类型
                returnData: [],  //订单数组
                groupNameList:[],//编组名称数组
                textModelMenu: {
                    update: "改派",
                    create: "派单"
                },
                textBatchMenu: {
                    update: "批量改派",
                    create: "批量派单"
                },
                dialogBatchStatus:'',  //批量派单&批量改派标题切换
                dislogModel:false,     //派单&改派弹出框显示&隐藏
                dialogModelStatus: "", //派单&改派标题切换
                modelForm:{            //派单&改派标题参数
                    engineerId:'',
                },
                modelFormRules:{       //派单&改派校验
                    engineerId: [{ required: true, message: "请选择工程师", trigger: "blur" }]
                },
                textGroupMenu: {
                    update: "修改编组",
                    create: "新建编组"
                },
                dialogGropFormVisible:false, //新建&修改编组标题
                dialogGroupStatus:"",        //新建&修改编组标题切换
                groupForm:{                  //新建&修改编组参数
                    label:'',
                    ids:[]
                },
                dialogDispatchForm:false,    //批量派单弹出框显示&隐藏
                dispatchForm:{               //批量派单参数
                    label:'',
                    engineerId:'',
                    nums:''
                },
                dispatchFormRules:{
                    engineerId: [{ required: true, message: "请选择工程师", trigger: "blur" }]
                },
                cancelDispatchForm:{         //批量派单参数
                    label:'',
                    ids:[],
                },
                spanArr:[],
                position:0,
                hoverOrderArr: [],
                tableHeight:'auto',
                basicsAuth:{
                    newLable:false,          //新建编组
                    editLabel:false,         //修改编组
                    saveGroupLabel:false,    //批量编组
                    sendOrders:false,        //派单
                    revertOrders:false,      //改派
                    sendGroupOrders:false,   //批量派单
                }
            }
        },
        mounted () {
            this.basicsAuth.newLable= getPermission('/api/workOrder/order/set_order_label');
            this.basicsAuth.editLabel= getPermission('/api/workOrder/order/set_order_label');
            this.basicsAuth.saveGroupLabel= getPermission('/api/workOrder/order/set_order_label');
            this.basicsAuth.sendOrders = getPermission('/api/workOrder/order/send_orders');
            this.basicsAuth.revertOrders= getPermission('/api/workOrder/order/revert_send_orders');
            this.basicsAuth.sendGroupOrders= getPermission('/api/workOrder/order/send_orders_batch');
            this.basicsAuth.revertOrdersBatch= getPermission('/api/workOrder/order/revert_orders_batch');
        },
        created(){
            this.getSendOrderList();      //获取订单列表
            this.pointEngineerListData(); //获取指定工程师列表
            this.getGroupNameData();      //获取分组名称列表
            this.getOrderNol();
            this.queryProvince();
        },
        methods: {
            //获取省
            queryProvince(){
                let query = {
                    parentId : 0
                }
                querySysRegion(query).then(res =>{
                    if(res.data.status == '100'){
                        this.provinceList = res.data.results;
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                });
            },
            queryCity(){
                let query = {
                    parentId : this.searchForm.province
                }
                querySysRegion(query).then(res => {
                    if(res.data.status == '100'){
                        this.cityList = res.data.results;
                        this.queryArea()
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                });
            },
            queryArea(){
                let query = {
                    parentId : this.searchForm.city
                }
                querySysRegion(query).then(res => {
                    if(res.data.status == '100'){
                        this.areaList = res.data.results;
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                });
            },
            // 选省
            choseProvince:function(e) {
                this.searchForm.city = '';
                this.searchForm.county = '';
                this.areaList = [];
                this.queryCity();
            },
            // 选市
            choseCity:function(e) {
                this.searchForm.county = null;
                this.queryArea();
            },
            //强制刷新
            changeEnginner(e){
                console.log(e);
                this.modelForm.engineerId = e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.modelForm.engineerId = val;
                    this.pickingPointEngineerList = result
                }else{
                    this.pickingPointEngineerList = this.copy;
                    this.modelForm.engineerId = "";
                }
            },
            //查询订单渠道
            getOrderNol(){
                let param = {
                    paraType : 'order_identifier',
                    startRow:1,
                    pageSize:10000
                }
                zhselectParameterInfoBusiness(param).then(res =>{
                    if(res.data.status == '100'){
                        this.OrderNolList = res.data.results.list
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            querySearchAsync(queryString, cb) {
                var groupNameList = this.groupNameList;
                var results = queryString ? groupNameList.filter(this.createStateFilter(queryString)) : groupNameList;
                cb(results);
            },
            createStateFilter(queryString) {
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            //获取编组名称列表
            getGroupNameData(){
                let para = {
                    onsiteTimeStarts:this.searchForm.onsiteTimeStarts,
                    onsiteTimeEnds:this.searchForm.onsiteTimeEnds
                }
                getLabelList(para).then(res => {
                    if (res.data.status==100) {
                        this.groupNameList = [];
                        res.data.results.forEach((item,index)=>{
                            this.groupNameList.push({
                                value:item
                            })
                        });
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })

            },
            //新建编组
            newGroup(){
                let isSelected = false;
                this.groupForm.ids = [];
                this.returnData.forEach((item,index) =>{
                    if(item.selected){
                        isSelected = true
                        this.groupForm.ids.push(item.id);
                    }
                });
                if(!isSelected){
                    this.$message({
                        message: '请先选择订单',
                        type: "warning"
                    });
                    return
                }
                this.dialogGroupStatus = "create";
                this.dialogGropFormVisible = true;
            },
            //修改编组
            eidtGroup(){
                let isSelected = false;
                this.groupForm.ids = [];
                this.returnData.forEach((item,index) =>{
                    if(item.selected){
                        isSelected = true
                        this.groupForm.ids.push(item.id);
                    }
                });
                if(!isSelected){
                    this.$message({
                        message: '请先选择订单',
                        type: "warning"
                    });
                    return
                }
                this.dialogGroupStatus = "update";
                this.dialogGropFormVisible = true;
            },
            //关闭编组弹框
            emptyGroupDialog(){
                this.dialogGropFormVisible = false;
                this.groupForm.label = "";
                this.$refs['groupForm'].resetFields();

            },
            //关闭批量派单弹框
            emptyDispatchDialog(){
                this.dialogDispatchForm = false;
                this.$refs['dispatchForm'].resetFields();
            },
            //新建批量派单弹框
            newDispatchDialog(type){
                let isSelected = false;
                this.dispatchForm.orderList = [];
                this.returnData.forEach((item,index) =>{
                    if(type == 0){
                        if(item.selected && (item.adminStatus == '03' || item.adminStatus == '38')){
                            isSelected = true
                            this.dispatchForm.orderList.push({id:item.id});
                            this.dispatchForm.label = item.label;
                        }
                    }else{
                        if(item.selected && item.adminStatus != '03' && item.adminStatus != '38'){
                            isSelected = true
                            this.dispatchForm.orderList.push({id:item.id});
                            this.dispatchForm.label = item.label;
                        }
                    }
                });
                if(!isSelected){
                    this.$message({
                        message: '请先选择订单',
                        type: "warning"
                    });
                    return
                }
                this.dispatchForm.nums = this.dispatchForm.orderList.length;
                this.dialogDispatchForm = true;
                this.dialogBatchStatus = (type == 0) ? "create" : "update";
            },
            //批量改派
            dispatchRevertFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        this.dispatchForm.orderList.forEach((item,index)=>{
                            item.engineerId = this.dispatchForm.engineerId
                        });
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        revertOrdersBatch({orderList : this.dispatchForm.orderList}).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: "改派成功",
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.emptyDispatchDialog();
                                /*刷新*/
                                this.getSendOrderList();
                                loading.close();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                                loading.close();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })

                    }else {
                        console.log('验证未通过');
                        return false;
                    }

                });
            },
            //提交批量派单
            dispatchFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        this.dispatchForm.orderList.forEach((item,index)=>{
                            item.engineerId = this.dispatchForm.engineerId
                        });
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        sendOrdersBatch({orderList : this.dispatchForm.orderList}).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: "派单成功",
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.emptyDispatchDialog();
                                /*刷新*/
                                this.getSendOrderList();
                                loading.close();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                                 loading.close();
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })

                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //批量解散
            cancelDispatchGroup(){
                let isSelected = false;
                this.cancelDispatchForm.ids = [];
                this.returnData.forEach((item,index) =>{
                    if(item.selected){
                        isSelected = true
                        this.cancelDispatchForm.ids.push(item.id);
                    }
                });
                if(!isSelected){
                    this.$message({
                        message: '请先选择订单',
                        type: "warning"
                    });
                    return
                }
                setOrderLabel(this.cancelDispatchForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: '解散成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getSendOrderList();

                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建&编辑编组
            setOrderLabelFuc(){
                setOrderLabel(this.groupForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*关闭弹窗*/
                        this.emptyGroupDialog();
                        /*刷新*/
                        this.getSendOrderList();

                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取某天时间
            getTimeDate(days){
                let startDate = new Date();
                let endDate = new Date();
                endDate.setDate(startDate.getDate() + days);
                let dataArr = [];
                let dataObj = {};
                let weeks = ['日', '一', '二', '三', '四', '五', '六'];
                while((endDate.getTime() - startDate.getTime()) >= 0) {
                    let year = startDate.getFullYear();
                    let month = (startDate.getMonth() + 1).toString().length == 1 ? "0" + (startDate.getMonth() + 1).toString() : (startDate.getMonth() + 1);
                    let day = startDate.getDate().toString().length == 1 ? "0" + startDate.getDate() : startDate.getDate();
                    dataArr.push({
                        startTime : new Date(year + '-' + month + "-" + day+' 00:00:00'),
                        endTime: new Date(year + '-' + month + "-" + day +' 23:59:59')

                    });
                    startDate.setDate(startDate.getDate() + 1);
                }
                this.searchForm.onsiteTimeStarts = dataArr[days].startTime;
                this.searchForm.onsiteTimeEnds = dataArr[days].endTime;
            },
            //选中订单
            checkFuc(row){
                if(row.label !== null&& row.label !==undefined){
                    this.returnData.forEach((item,index)=>{
                        if(item.label == row.label){
                            item.selected = row.selected
                        }
                    })
                }
            },
            //获取指派工程师列表
            pointEngineerListData(){
                let para = {
                    provinceId:this.modelForm.province
                }
                engineerListArea(para).then(res => {
                    if (res.data.status==100) {
                        this.pickingPointEngineerList = res.data.results;
                        this.copy = Object.assign(this.pickingPointEngineerList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs['modelForm'].resetFields();
            },
            //确定新建派单
            addModelFormSubmitBtn(formname,type){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        (type==0) ? this.submitDispatchSingle() : this.submitDispatchReverse();
                        loading.close();
                    }else {
                        console.log('验证未通过');
                        return false;
                    }

                });
            },
            //提交改派
            submitDispatchReverse(){
                revertSendOrders(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getSendOrderList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //提交派单
            submitDispatchSingle(){
                sendOrders(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getSendOrderList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建派单
            newModel(item,type) {
                item.faultSubclassStr = "";
                item.faultSubclass.forEach((item1,index) =>{
                    if(item1.faultSubclassName){
                        item.faultSubclassStr += item1.faultSubclassName
                    }
                });
                this.modelForm = Object.assign({}, item);
                this.modelForm.time = this.modelForm.onsiteDate+' '+this.modelForm.onsiteTimeStart+' ~ '+this.modelForm.onsiteTimeEnd;
                this.modelForm.modelDetail = this.modelForm.modelName+' '+this.modelForm.colorName;
                this.pointEngineerListData();
                this.dislogModel = true;
                this.dialogModelStatus = (type == 0) ? "create" : "update";
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.adminStatusList = ["03", "05", "06", "07", "38", "39","40"];
                this.searchForm.isNeedLabelSort = 1;
                this.searchForm.orderIdentifierList=[];
                this.getSendOrderList();
            },
            //获取待派单列表
            getSendOrderList(){
                this.getTimeDate(this.periodType);  //获取派单日期
                selectWorkOrder(this.searchForm).then(res => {
                    if (res.data.status==100) {
                        res.data.results.list.forEach((item,index)=>{
                            item.selected = false;
                            item.countyName = item.countyName ? item.countyName : '';
                        })
                        this.returnData = res.data.results.list;
                        this.rowspan();
                        this.tableHeight = '700';
                        console.log(this.tableHeight)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //表格合并
            rowspan() {
                this.spanArr = [];//在data里面定义
                this.position = 0; //在data里面定义
                this.returnData.forEach((item,index) => {
                    if( index === 0){
                        this.spanArr.push(1);
                        this.position = 0;
                        item.sequence=index+1;//设置序号
                    }else{
                        if(this.returnData[index].label !== null&& this.returnData[index].label != undefined){
                            if(this.returnData[index].label === this.returnData[index-1].label ){
                                this.spanArr[this.position] += 1;//连续有几行项目名名称相同
                                this.spanArr.push(0); // 名称相同后往数组里面加一项0
                                //当项目名称相同时，设置当前序号和前一个相同
                                this.returnData[index].sequence = this.returnData[index-1].sequence;
                            }else{
                                this.spanArr.push(1);
                                this.position = index;
                                //当项目名称不同时，将当前序号设置为前一个序号+1
                                this.returnData[index].sequence = this.returnData[index-1].sequence+1;
                            }
                        }else{
                            this.spanArr.push(1);
                            this.position = index;
                            //当项目名称不同时，将当前序号设置为前一个序号+1
                            this.returnData[index].sequence = this.returnData[index-1].sequence+1;
                        }
                    }
                })
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {  //表格合并行
                if(columnIndex === 0){  //序号列也进行合并(第一列)
                    //this.spanArr这个数组里面存的是table里面连续的有几条数据相同
                    //例如:[1,1,2,0,2,0]
                    //1  代表的没有连续的相同的
                    //2  代表连续的两个相同
                    //0  代表是和上一条内容相同
                    //console.log(this.spanArr)
                    const _row = this.spanArr[rowIndex];
                    const _col = _row>0 ? 1 : 0;
                    return {
                        rowspan: _row, //行
                        colspan: _col  //列
                    }
                }
            },
            tableRowClassName: function ({row,rowIndex}) {
                var arr = this.hoverOrderArr;
                for (var i = 0; i < arr.length; i++) {
                    if (row.label == arr[i].label) {
                        return 'warning-row'
                    }
                }
                if (row.sequence % 2 == 0) {
                    return 'blue-row';
                } else{
                    return 'success-row';
                }
            },
            cellMouseEnter: function (row, column, cell, event) {
                this.hoverOrderArr = [];
                this.returnData.forEach((item,index)=>{
                    if(item.label == row.label && item.label !== null && item.label !==undefined){
                        this.hoverOrderArr.push(item)
                    }
                })
            },
            cellMouseLeave: function (row, column, cell, event) {

            },
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss">
    #dispatchReady{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        .el-form-item{
            margin-right:0;
            margin-bottom:15px
        }
        .success-row{
            background:#f0f9eb!important
        }
        .el-table .warning-row {
            background: oldlace;
        }

        .hover-row td {
            background-color: oldlace!important
        }
        .blue-row{
            background-color:light;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .shiftTime{
            li{
                display:inline-block;
                margin-right:10px;
                font-size:14px;
                color:#666;
                margin-bottom:15px;
                cursor:pointer
            }
            li:nth-child(1){
                margin-right:5px;
                cursor:default
            }
            li.active{
                color:#409EFF
            }
        }
        .el-dialog__footer{
            text-align:center !important
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>





// WEBPACK FOOTER //
// dispatchReady.vue?4d3e11dc